import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastAccountDigits'
})
export class LastAccountDigitsPipe implements PipeTransform {

  transform(value: string | number[], account: number, disabled = false): string | number[] {
    const accountToSubstr = account.toString();

    if (!value) {
      return '';
    }

    if (disabled) {
      return value;
    }

    if (typeof value === 'string') {
      return value.replace(/#LastAccountDigits/g, accountToSubstr.substr(accountToSubstr.length - 3));
    }

    return value
      .filter(_val => _val.toString().length > 3)
      .map(_val => {
        const val = _val.toString();
        return +(val.slice(0, -3) + accountToSubstr.substr(accountToSubstr.toString().length - 3));
      });
  }

}
